export default __webpack_public_path__ + "static/media/title_book.093da8b6.png";